import { SyntheticEvent, useCallback, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useRecoilState } from 'recoil';
import { popupsSelector } from 'src/stores/main';
import { popupsMap } from './constants';

import './style.scss';

const Popups = () => {
    const wrapperRef = useRef(null);
    const [openPopup, setOpenPopup] = useRecoilState(popupsSelector);
    const betslipWrapperElem = useMemo(() => openPopup && document.querySelector('#root'), [openPopup]);

    const onClick = (e: SyntheticEvent) => {
        e.target === wrapperRef?.current && setOpenPopup(undefined);
    };
    
    const closePopup = useCallback(() => setOpenPopup(undefined), []);

    const Component = openPopup && popupsMap[openPopup.key];

    if (!betslipWrapperElem || !Component) return null;

    return ReactDOM.createPortal(
        <div className="B-popup-wrapper" onPointerDown={onClick} ref={wrapperRef}>
            <Component {...(openPopup.props || {})} closePopup={closePopup} />
        </div>,
        betslipWrapperElem,
    );
};

export default Popups;